import React from 'react'
import { DepositHeader } from '../index'
import TipsView from '../Components/TipsView'
import UploadFile from '../Components/UploadFile'
import MoneyInput from '../Components/MoneyInput'
import UserBankSelect from '../Components/UserBankSelect'
import OldBankSixNumber from '../Components/OldBankSixNumber'
import SuccessPage from '../Components/SuccessPage'
import DatePicker from '../Components/DatePicker'
import SubmitBtn from '../Components/SubmitBtn'
import OldBankCon from '$Deposits/Components/LB/OldBank'
import Modal from '../Components/Modal'



class OldBank extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {

        return (
            <>
                <OldBankCon
                    FileModal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}

                    OldBank={(propCon) => {
                        const {
                            MethodsActive,
                            onChange,
                            submitBtn,
                            backClick,
                        } = propCon
                        return (
                            <div className='oldBankModal'>
                                <div className='oldBankHeader'>
                                    < span className='backClick' onClick={backClick} />
                                    <h3>
                                        Chuyển Vào Tài Khoản Cũ
                                    </h3>
                                </div>
                                <div className='oldBankModalCenter'>

                                    <div className='viewArea'>
                                        <TipsView msg={'Vui lòng điền thông tin tài khoản ngân hàng FUN88 bạn đã chuyển khoản và nhấn “Gửi” để tạo lệnh gửi tiền.'} />
                                        <MoneyInput />
                                        <UserBankSelect />
                                        <OldBankSixNumber />
                                        <div className='DatePickerolumn'>
                                            <div>
                                                {/* 日期选择 */}
                                                <p className='inputTitle'>Ngày Gửi</p>
                                                <DatePicker
                                                    mode={'date'}
                                                    titleText={'Chọn Ngày'}
                                                />
                                            </div>
                                            <div>
                                                {/* 时间选择 */}
                                                <div className='inputTitle time-title-container'>
                                                    <p>Thời Gian Gửi</p>
                                                    <span className="required-label">Bắt buộc</span>
                                                </div>
                                                <DatePicker
                                                    mode={'time'}
                                                    titleText={'Chọn Ngày'}
                                                />
                                            </div>
                                        </div>



                                        {/* 上传图片 */}
                                        <div style={{ paddingTop: 20 }}>
                                            <UploadFile />
                                        </div>
                                    </div>

                                    <SubmitBtn
                                        submitBtn={submitBtn}
                                        onPress={onChange}
                                        submitBtnItem={'Gửi'}
                                    />
                                </div>
                            </div>
                        )
                    }}
                    SuccessPage={SuccessPage}
                />

            </>
        );
    }
}

export default OldBank


